import axios from 'axios'
import {fetchUrl} from '../constants/constants'
import setAuthTokens from './setAuthTokens'

// Endpoints that must never trigger the 401 refresh flow (their own errors
// belong to the caller, and refreshing from them would loop).
const excludedUrls = ['session-login', 'api-token-refresh', 'handoff-exchange', 'sync-cookies', 'refresh-cookies', 'logout']

let installed = false

export const setupAuthInterceptor = () => {
    if (installed) {
        return
    }
    installed = true

    axios.interceptors.response.use(
        response => response,
        error => {
            const config = error.config
            const status = error.response && error.response.status
            const url = (config && config.url) || ''

            if (!config || status !== 401 || config._retry || !url || !localStorage.getItem('tokenName')) {
                return Promise.reject(error)
            }
            if (excludedUrls.some(name => url.includes(name))) {
                return Promise.reject(error)
            }

            config._retry = true
            // Refresh authenticates from the httpOnly insrefresh cookie alone;
            // a missing cookie simply fails this POST and hits the catch below.
            // window.fetch keeps this off global axios, whose
            // defaults.headers.common['Authorization'] still holds the expired
            // token here and would 401 the request before the AllowAny view runs.
            return fetch(fetchUrl + 'refresh-cookies/', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: '{}'
            }).then(res => {
                if (!res.ok) {
                    throw new Error('refresh-cookies failed with status ' + res.status)
                }
                return res.json()
            }).then(res => {
                const access = res.token
                // The server rotated the pair and set both cookies; keep the
                // localStorage access token at its keyed name.
                let tokenName = localStorage.getItem('tokenName')
                if (!tokenName) {
                    // Edge state: the pointer is gone; adopt the name the server
                    // reports and persist it for next mount (mirrors AppMain).
                    tokenName = res.token_cookie_name
                    localStorage.setItem('tokenName', tokenName)
                }
                localStorage.setItem(tokenName, access)
                setAuthTokens(access)

                // Retry the original request; defaults now carry the fresh Authorization header.
                // config.headers still holds the stale Authorization from the original request
                // and per-request headers override the refreshed defaults, so overwrite it.
                config.headers.Authorization = 'JWT ' + access
                return axios(config)
            }).catch(() => {
                const tokenName = localStorage.getItem('tokenName')
                localStorage.removeItem(tokenName)
                localStorage.removeItem('tokenName')
                setAuthTokens()
                window.location.reload()
                return Promise.reject(error)
            })
        }
    )
}
